<div class="wrapper">
    <div class="header row gap center-children-horizontally">
      <h2 class="confirm-title cooper">{{ 'feedback.title' | translate }}</h2>
    </div>
    <section class="column center-children-vertically margin-top">
        <div class="font-18 subtitle">{{ 'feedback.intro' | translate }}</div>
        <div class="font-18 subtitle">{{ 'feedback.navigate' | translate }}</div>
        <div class="font-18">{{ 'feedback.more' | translate }}</div>
        <form class="feedback-form content margin-top" [formGroup]="feedbackForm" (submit)="sendFeedback()">
            <div class="column gap center-children">
                <app-emoji-selector [emojiSelected]="emojiSelected" formControlName="rating"/>
                <textarea class="margin-bottom" formControlName="comment" [placeholder]="'feedback.placeholder' | translate"></textarea>
                <div class="row gap margin-top">
                    <app-button  [disabled]="!feedbackForm.valid || loading" type="submit" title="Confirmer"  [outline]="true">
                      {{ 'feedback.confirm' | translate }}<span *ngIf="loading">...</span>
                    </app-button>
                    <app-button title="Annuler" (onClick)="handleCancel()" type="button">
                        {{ 'feedback.later' | translate }}
                      </app-button>
                </div>
            </div>
        </form>
    </section>
</div>
